import { Component, inject, output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getApiErrorMessage } from 'src/app/_helpers/api-error.helpers';
import { CancellationService } from 'src/app/_services/cancellation.service';
import { ActionModalComponent } from 'src/app/shared/components/action-modal/action-modal.component';

/**
 * « Supprimer »: a cancellation opened by mistake goes away. The deletion is
 * soft — the timeline keeps who removed it — and the server refuses anything
 * the customer has already signed, so the caller only has to ask.
 */
@Component({
  selector: 'app-cancellation-delete-modal',
  standalone: true,
  imports: [ActionModalComponent],
  templateUrl: './cancellation-delete-modal.component.html',
})
export class CancellationDeleteModalComponent {
  private readonly cancellationService = inject(CancellationService);

  private readonly toastr = inject(ToastrService);

  /** It is gone: the list refetches, the sheet showing it closes. */
  readonly deleted = output<void>();

  @ViewChild('actionModal')
  private actionModal?: ActionModalComponent;

  private cancellationId: string | null = null;

  protected submitted = false;

  openModal(cancellationId: string): void {
    this.cancellationId = cancellationId;
    this.submitted = false;
    this.actionModal?.openModal();
  }

  closeModal(): void {
    this.actionModal?.closeModal();
  }

  protected confirm(): void {
    const id = this.cancellationId;
    if (!id || this.submitted) return;
    this.submitted = true;
    this.cancellationService.deleteCancellationFlow(id).subscribe({
      next: () => {
        this.submitted = false;
        this.toastr.success($localize`Résiliation supprimée`);
        this.deleted.emit();
        this.actionModal?.closeModal();
      },
      error: (err) => {
        this.submitted = false;
        this.toastr.error(
          getApiErrorMessage(
            err,
            $localize`Une erreur est survenue. Veuillez réessayer`
          )
        );
      },
    });
  }
}
